import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-list-addon',
  templateUrl: './list-addon.component.html',
  styleUrls: ['./list-addon.component.css']
})
export class ListAddonComponent implements OnInit {

selectedStatus: any = ''
  addons: any = [];
  appointmentId: any;
  filterAddonList:any;
  totalPages = 0;
  totalResults = 0;
  currentPage:number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  search:any;
  status = true;
  userPermission=UserPermission
  addonModalObj:any

  constructor(private addonService: AddonService,public permissionService: PermissionService){

  }

  ngOnInit(){
    this.getAllAddons(this.currentPage);
  }

  getAllAddons(page:number){
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.addonService.getAddons(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) =>{
      if(data.results ){
        this.addons = data.results;
        this.addons = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
      }
    })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllAddons(page);
  }

  onSelectStatus(): void {
    this.getAllAddons(this.currentPage = 1);
  }


  openAddonModal(addon: any) {
    this.addonModalObj = addon;
  }

  onSaveAddon(evt: any) {
    if (evt) {
      const idx = this.addons.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.addons[idx] = evt;
      } else {
        this.addons.splice(idx, 1);
      }
    }
    this.addonModalObj = null;
  }

  onCloseAddonModal() {
    this.addonModalObj = null;
  }

}
